!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, n = t.parcelRequire5f74;
  null == n && ((n = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var n = i[t];
      delete i[t];
      var s = {
        id: t,
        exports: {}
      };
      return e[t] = s, n.call(s.exports, s, s.exports), s.exports;
    }
    var r = new Error("Cannot find module '" + t + "'");
    throw r.code = "MODULE_NOT_FOUND", r;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = n), (0, n.register)("6ph3s", function(t, e) {
    var i, n, s, r;
    i = t.exports, n = "default", s = function() {
      return o;
    }, Object.defineProperty(i, n, {
      get: s,
      set: r,
      enumerable: !0,
      configurable: !0
    });
    var o = (t, e) => {
      const i = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD", "SEK", "DKK", "NOK", "CHF" ].includes(e), n = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD" ].includes(e);
      if (i) {
        return `${n ? "$" : ""}${Shopify.formatMoney(t, "{{amount_no_decimals}}")} <span class="text-3xs">${e}</span>`;
      }
      return Shopify.formatMoney(t, Shopify.money_format).replace(/\.00$/, "");
    };
  });
  var s = n("6ph3s");
  customElements.get("product-form-sticky") || customElements.define("product-form-sticky", class extends HTMLElement {
    constructor() {
      super(), this.formID = this.getAttribute("data-form"), this.productFormEl = document.querySelector(`product-form[form="${this.formID}"]`), 
      this.stickyBarEl = this.querySelector("[data-sticky]"), this.atcButtonEl = this.stickyBarEl?.querySelector('button[type="submit"]'), 
      this.priceEls = this.querySelectorAll("[data-price]"), this.compareAtPriceEls = this.querySelectorAll("[data-compare-at-price]"), 
      this.handleChange = this._handleChange.bind(this), this.handleDisabledClick = this._handleDisabledClick.bind(this), 
      this.handleIntersection = this._handleIntersection.bind(this);
    }
    connectedCallback() {
      if (!this.productFormEl || !this.stickyBarEl || !this.atcButtonEl) return void console.warn("[ProductFormSticky] Missing required elements, component disabled.", {
        formID: this.formID
      });
      this.productFormEl.addEventListener("variant:change", this.handleChange), this._updateVariantState(this.productFormEl.currentVariant);
      const t = this.productFormEl.querySelector("[data-atc]");
      t && (this.observer = new IntersectionObserver(this.handleIntersection, {
        rootMargin: "-100px 0px 0px 0px"
      }), this.observer.observe(t));
    }
    disconnectedCallback() {
      this.observer?.disconnect(), this.productFormEl?.removeEventListener("variant:change", this.handleChange), 
      this.atcButtonEl?.removeEventListener("click", this.handleDisabledClick), document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
        detail: {
          source: "product-form-sticky",
          transform: ""
        }
      }));
    }
    _handleChange(t) {
      this._updateVariantState(t.detail?.variant);
    }
    _updateVariantState(t) {
      this.currentVariant = t, this._updatePrice(), this._updateButton();
    }
    _updateButton() {
      const t = this.currentVariant, e = t?.available, i = t && !e;
      let n;
      n = e ? window.strings.addToCart : i ? window.strings.soldOut : window.strings.selectOptions;
      const s = !e, r = this.atcButtonEl.querySelector("[data-atc-text]");
      r ? r.textContent = n : this.atcButtonEl.textContent = n, this.atcButtonEl.closest("[data-sticky]") || (this.atcButtonEl.disabled = s), 
      this.atcButtonEl.classList.toggle("btn--primary", !s), this.atcButtonEl.classList.toggle("btn--secondary", s);
      const o = this.atcButtonEl.querySelector("[data-atc-price]");
      o?.classList.toggle("hidden", s), o?.classList.toggle("flex", !s), s ? this.atcButtonEl.addEventListener("click", this.handleDisabledClick) : this.atcButtonEl.removeEventListener("click", this.handleDisabledClick);
    }
    _updatePrice() {
      const t = this.currentVariant, e = t?.price ?? 0, i = t?.compare_at_price ?? 0, n = i > e;
      this.priceEls.forEach(i => {
        i.innerHTML = (0, s.default)(e, window.Shopify.currency.active);
        const r = i.parentElement.hasAttribute("data-is-atc");
        i.classList.toggle("text-red", n && !r), i.parentElement.classList.toggle("flex-row-reverse", n && !r), 
        r && (i.parentElement.classList.toggle("hidden", !t?.available), i.parentElement.classList.toggle("flex", t?.available));
      }), this.compareAtPriceEls.forEach(t => {
        const e = t.parentElement.hasAttribute("data-is-atc");
        t.innerHTML = n && !e ? (0, s.default)(i, window.Shopify.currency.active) : "";
      });
    }
    _handleDisabledClick(t) {
      t.preventDefault(), t.stopPropagation(), this.productFormEl.querySelector(".product-form__option")?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
    _handleIntersection(t) {
      const e = t[0].isIntersecting, i = t[0].boundingClientRect.y < window.innerHeight, n = !e && i;
      this.stickyBarEl.classList.toggle("translate-y-full", !n), this.stickyBarEl.classList.toggle("opacity-0", !n), 
      this.stickyBarEl.classList.toggle("pointer-events-none", !n), this._adjustLoadingSpinnerPosition(n);
    }
    _adjustLoadingSpinnerPosition(t) {
      if (t) {
        const t = this.stickyBarEl.offsetHeight, e = window.getComputedStyle(this.stickyBarEl), i = t + (parseInt(e.marginTop, 10) || 0) + (parseInt(e.marginBottom, 10) || 0);
        document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "product-form-sticky",
            transform: `translateY(-${i}px)`
          }
        }));
      } else document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
        detail: {
          source: "product-form-sticky",
          transform: ""
        }
      }));
    }
  });
}();